<section class="two-col-two-row-panel" *ngIf="data" #panelElRef>
	<top-wave *ngIf="data.topWave.value === true"></top-wave>
	<div class="two-col-two-row-panel__content" #contentElRef>
		<h2 *ngIf="data.title.value" class="two-col-two-row-panel__title" #titleEl>{{ data.title.value }}</h2>
		<h3 *ngIf="data.subtitle.value" class="two-col-two-row-panel__subtitle" #subtitleEl>{{ data.subtitle.value }}</h3>
		<div *ngIf="data?.items?.value" class="two-col-two-row-panel__wrapper"
				 [ngClass]="{
					'two-col-two-row-panel__order' : (data.order.value === true),
					'two-col-two-row-panel__align-items' : (data.alignItems.value === true)}"
				 #wrapperEl>
			<div *ngFor="let item of data.items.value; let i=index"
					 [class]="'two-col-two-row-panel__div
									 two-col-two-row-panel__order-'+(i+1)+'
									 two-col-two-row-panel__item-card
									 rte'"
					 #itemEl>
				<h2 *ngIf="item?.title?.value"
						class="two-col-two-row-panel__item-title">
					{{ item.title.value }}
				</h2>
				<div *ngIf="item?.description?.value && !item?.media?.value?.image && !item?.media?.value?.video?.mobile && !item?.media?.value?.video?.desktop"
						 class="rte"
						 [innerHTML]="item.description.value | safe"></div>
				<div *ngIf="lazyLoad">
					<ng-container *ngIf="item?.animationUrl?.value || item?.media?.value?.image || item?.media?.value?.video?.mobile || item?.media?.value?.video?.desktop">
						<ng-container *ngTemplateOutlet="item?.animationUrl?.value ? animationBlock : mediaBlock; context{item: item}"></ng-container>
					</ng-container>
				</div>
				<div *ngIf="item.link?.value?.length > 0"
						 class="two-col-two-row-panel__item-links-wrapper">
					<app-bg-button *ngFor="let link of item.link?.value"
												 [buttonColor]="link.color.value"
												 class="two-col-two-row-panel__item-link"
												 [data]="link.link.value">
					</app-bg-button>
				</div>
			</div>
		</div>
		<div class="two-col-two-row-panel__link" *ngIf="data.links?.value?.length">
			<app-bg-button *ngFor="let link of data.links.value"
										 [buttonColor]="link.color.value"
										 class="two-col-two-row-panel__button"
										 [data]="link.link.value">
			</app-bg-button>
		</div>
	</div>
	<bottom-wave *ngIf="data.bottomWave.value === true"></bottom-wave>
</section>

<ng-template #animationBlock let-item="item">
	<ng-lottie [options]="item.options" (animationCreated)="animationCreated($event)"></ng-lottie>
</ng-template>

<ng-template #mediaBlock let-item="item">
	<ng-container *ngTemplateOutlet="item?.media?.value?.image ? imageBlock : videoBlock; context: {item: item}"></ng-container>
</ng-template>

<ng-template #imageBlock let-item="item">
	<app-picture class="hero-panel__media-holder" *ngIf="item?.media?.value?.image && lazyLoad" [data]="item.media.value.image"></app-picture>
</ng-template>

<ng-template #videoBlock let-item="item">
	<div *ngIf="item?.media?.value?.video?.mobile || item?.media?.value?.video?.desktop">
		<div (click)="open(item)" class="two-col-two-row-panel__thumbnail">
			<div class="two-col-two-row-panel__thumbnail-img">
				<img src="{{ item.videoData.thumbnail.src }}"
				alt=""
				[ngStyle]="{aspectRatio: item.videoData?.thumbnail?.width / item.videoData?.thumbnail?.height}" />
			</div>
		</div>
		<app-modal-video class="two-col-two-row-panel__modal" *ngIf="item.isShow" [data]="item.videoData" [isShow]="item.isShow" (close)="close(item)"></app-modal-video>
	</div>
</ng-template>
